import { render, staticRenderFns } from "./EmployeeEducation.vue?vue&type=template&id=8d3b33f2&"
import script from "./EmployeeEducation.vue?vue&type=script&lang=js&"
export * from "./EmployeeEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports